const LOCAL_STORAGE_KEY = 'shopify-wishlist';
const DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

const API_BASE = "https://api.belaci.com"; // change this

// 👤 Check Customer
const getCustomerId = () => {
  if (window.Shopify && Shopify.customer) {
    return Shopify.customer.id;
  }
  return null;
};

// 📦 LOCAL STORAGE
const getLocalWishlist = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEY);
  return data ? data.split(DELIMITER) : [];
};

const setLocalWishlist = (arr) => {
  if (arr.length) localStorage.setItem(LOCAL_STORAGE_KEY, arr.join(DELIMITER));
  else localStorage.removeItem(LOCAL_STORAGE_KEY);
};

// 🌐 API
const fetchApiWishlist = async () => {
  console.log('dfsfsdfsdfsd')
  try{
  const customerId = getCustomerId();
  if (!customerId) return [];

  const res = await fetch(`${API_BASE}/wishlist/get?logged_in_customer_id=${customerId}`);
  const data = await res.json();

  return data.wishlist ? data.wishlist.split(',') : [];
  }catch{
    return ['diamond-tip-bent-nail-gold-plated-bracelet-for-women'];
  }
};

const saveApiWishlist = async (wishlist) => {
  try{
  const customerId = getCustomerId();
  if (!customerId) return;

  await fetch(`${API_BASE}/wishlist/update?logged_in_customer_id=${customerId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ wishlist: wishlist.join(',') })
  });
}catch{
  
}
};

// 🧠 MAIN GET
const getWishlist = async () => {
  const customerId = getCustomerId();

  if (customerId) {
    return await fetchApiWishlist();
  } else {
    return getLocalWishlist();
  }
};

// 💾 MAIN SAVE
const saveWishlist = async (wishlist) => {
  const customerId = getCustomerId();

  if (customerId) {
    await saveApiWishlist(wishlist);
  } else {
    setLocalWishlist(wishlist);
  }

  document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist }
  }));
};

// 🔄 MERGE AFTER LOGIN (VERY IMPORTANT)
const mergeWishlistOnLogin = async () => {
  const customerId = getCustomerId();
  if (!customerId) return;

  const localWishlist = getLocalWishlist();
  if (!localWishlist.length) return;

  const apiWishlist = await fetchApiWishlist();

  const merged = [...new Set([...apiWishlist, ...localWishlist])];

  await saveApiWishlist(merged);
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

// ❤️ UPDATE
const updateWishlist = async (handle) => {
  let wishlist = await getWishlist();

  const index = wishlist.indexOf(handle);
  if (index === -1) wishlist.push(handle);
  else wishlist.splice(index, 1);

  await saveWishlist(wishlist);
  updateWishlistCount(wishlist);
};

// 🔢 COUNT
const updateWishlistCount = (wishlist) => {
  $('[data-js-wishlist-count]')
    .attr('data-js-wishlist-count', wishlist.length)
    .html(wishlist.length);

  if (wishlist.length === 0) {
    $(".wish-info").show();
  } else {
    $(".wish-info").hide();
  }
};

// 🧱 PRODUCT CARD
const fetchProductCardHTML = (handle) => {
  return fetch(`/products/${handle}?view=card`)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selectors.productCard).outerHTML;
    });
};

// 🧱 GRID
const setupGrid = async (grid) => {
  const wishlist = await getWishlist();

  const responses = await Promise.all(wishlist.map(fetchProductCardHTML));

  grid.innerHTML = responses.join('');
  grid.classList.add(GRID_LOADED_CLASS);

  initButtons();

  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist }
  }));
};

// ❤️ BUTTONS
const setupButtons = async (buttons) => {
  const wishlist = await getWishlist();

  buttons.forEach((button) => {
    const handle = button.dataset.productHandle;
    if (!handle) return;

    if (wishlist.includes(handle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }

    button.addEventListener('click', async () => {
      await updateWishlist(handle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });

  updateWishlistCount(wishlist);
};

// 🚀 INIT
const initGrid = () => {
  const grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button);
  if (buttons.length) setupButtons(buttons);
};

// 🎬 LOAD
document.addEventListener('DOMContentLoaded', async () => {
  await mergeWishlistOnLogin(); // 🔥 magic line
  initButtons();
  initGrid();
});